import star from "@/assets/svg/landing/star.svg"
import verified from "@/assets/svg/landing/verified.svg"

import { REVIEWS } from "../../config/landing-content"
import { SectionTitle } from "../section-title"

export function ReviewsSection() {
  return (
    <section data-slot="reviews-section" className="flex flex-col gap-4 px-4">
      <SectionTitle>What users say about Live Palmistry</SectionTitle>

      {REVIEWS.map((review) => (
        <div
          key={review.name}
          className="flex flex-col gap-4 rounded-[16px] border border-purple-light/20 p-4"
        >
          <p className="text-base leading-snug text-purple-light/70">{review.text}</p>

          <div className="flex items-center justify-between gap-4">
            <div className="flex min-w-0 flex-1 items-center gap-2">
              <img src={review.avatar} alt="" className="size-10 shrink-0 rounded-full object-cover" />
              <div className="flex min-w-0 flex-col">
                <p className="font-display text-base font-medium text-purple-light">{review.name}</p>
                <div className="flex items-center gap-1">
                  <div className="flex items-center">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <img key={i} src={star} alt="" className="size-4" />
                    ))}
                  </div>
                  <span className="text-sm font-medium leading-5 text-gold">{review.rating}</span>
                </div>
              </div>
            </div>

            <div className="flex shrink-0 items-center gap-1 rounded-[14px] bg-green/10 py-1.5 pl-1.5 pr-2">
              <img src={verified} alt="" className="size-4" />
              <span className="text-xs font-semibold text-green">Verified review</span>
            </div>
          </div>
        </div>
      ))}
    </section>
  )
}
